<template>
  <div class="start-time">
    {{ stopwatch }}
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "QuestionBankCheckStopwatch",
  components: {},
  props: {
    value: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      hourNum: 0,
      stopwatch: "00:00:00",
      startTime: [],
      // 定时器
      stopwatchTimer: ""
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    startStopwatch() {
      // if (this.drillPlanDetail.status == 1) {
      //   var time1 = moment
      //     .unix(this.drillPlanDetail.openTime)
      //     .format("YYYY-MM-DD HH:mm:ss");
      // } else {
      //   var time1 = moment();
      // }
      var time1 = moment();
      // console.log(time1)
      let time2 = moment();
      // console.log(time2);
      let diffTime = time2.diff(time1, "second");
      // console.log(diffTime)
      if (diffTime < 0) {
        diffTime = 0;
        this.$message("您电脑的时间不正确，请修改电脑时间！");
      }
      this.formatSeconds(diffTime);
    },
    startWatch() {
      this.stopwatchTimer = setInterval(() => {
        this.timer(this.startTime);
      }, 1000);
    },
    clearStartWatch() {
      this.stopwatch = "00:00:00";
      clearInterval(this.stopwatchTimer);
      this.startTime = [];
      // this.startWatch = null;
    },
    formatSeconds(value) {
      var second = parseInt(value); // 秒
      var minute = 0; // 分
      var hour = 0; // 小时
      if (second > 60) {
        minute = parseInt(second / 60);
        second = parseInt(second % 60);
        if (minute > 60) {
          hour = parseInt(minute / 60);
          minute = parseInt(minute % 60);
        }
      }
      this.startTime = [hour, minute, second];
      this.startWatch();
      // console.log(this.startTime)
    },
    timer(time) {
      // console.log(startTime)
      let h = time[0];
      let m = time[1];
      let s = time[2];
      let hourNum = h * 60 + m;
      if (s/60 != 0) {
        hourNum++;
      }
      this.hourNum = hourNum;
      this.$emit("input", hourNum);
      // console.log(this.hourNum);
      s++;
      if (s >= 60) {
        s = 0;
        m++; //分钟
      }
      if (m >= 60) {
        m = 0;
        h++; //小时
      }
      this.startTime = [h, m, s];
      this.stopwatch =
        this.modifyTime(h) +
        ":" +
        this.modifyTime(m) +
        ":" +
        this.modifyTime(s);
      // console.log(this.stopwatch);
    },
    // 修改秒表结构(补 0 操作)
    modifyTime(n) {
      if (n < 10) {
        n = "0" + n;
      } else {
        n = n;
      }
      return n;
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.start-time {
  text-align: right;
}
</style>
